import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';

import { formatCurrency } from '../../../utils/util';

import { useTheme } from '@mui/material';

const BalanceInfo = styled(BasicFlex)`
  font-size: 1.2rem;
  width: max-content;
  color: ${props => props.theme.colors.mildText};
  font-weight: 500;
`

const Pill = styled(BasicFlex)`
  width: fit-content;
  padding: .3rem .8rem;
  border-radius: 10px;
  background-color: ${props => props.$bg};
  color: ${props => props.$color};
  font-size: 1.2rem;
`

const TotalInfo = styled.div`
  text-align: right;
  width: max-content;
`




const WigBalance = ({ wig }) => {
  let bg, color, Icon, balText;

  const theme = useTheme();

  if (wig.sold_balance_due === 0) {
    bg = theme.palette.success.light;
    color = theme.palette.success.main;
    Icon = CheckRoundedIcon;
    balText = "Paid";
  } else {
    bg = theme.palette.error.light;
    color = theme.palette.error.main;
    Icon = PriorityHighRoundedIcon;
    balText = "Bal";
  }
  return (
    <BalanceInfo dir="column" gap=".4rem">
      <Pill $bg={bg} $color={color}> <Icon fontSize="small" sx={{ fontSize: "1.4rem"}} /> {formatCurrency(wig.sold_balance_due)}</Pill>
      <TotalInfo><span>{formatCurrency(wig.sold_price)}&nbsp;&middot;&nbsp;{formatCurrency(wig.sold_paid)}</span></TotalInfo>
    </BalanceInfo>
  )
};

export default WigBalance